export default {
    message: {

        getStudentDataByPhoneAndName:  '/customer/getStudentDataByPhoneAndName ',//家长绑定学生姓名手机号
        storeParentCensusQuestion:  '/customer/storeParentCensusQuestion',//家长添加编辑问卷信息
        detailParentCensusQuestion:  '/customer/detailParentCensusQuestion',//返回已添加的家长问卷信息
        detailParentInfo:  '/customer/detailParentInfo',//获取家长绑定的学生信息
        // storeParentInfo:  '/customer/storeParentInfo',
    },

    student: {
        //学生信息
        studentMessage: {
            grade: {
                getAchievementListByParent:  '/customer/getAchievementListByParent',//学生信息 - 成绩列表
                detailAchievementByParent: '/customer/detailAchievementByParent',// 学生信息 - 成绩添加
            },
            competition: {
                getCompetitionInfoListByParent: '/customer/getCompetitionInfoListByParent',//学生信息 - 竞赛信息列表
                detailCompetitionInfoByParent: '/customer/detailCompetitionInfoByParent',//学生信息 - 入参是列表的主键id
            },
            quality: {
                getComplexQualityListByParent: '/customer/getComplexQualityListByParent',//学生信息 - 综合素质信息列表
                detailComplexQualityByParent: '/customer/detailComplexQualityByParent',//学生信息 - 综合素质信息详情
            },
            studentQues: {
                getStudentCensusQuestionByParent: '/customer/getStudentCensusQuestionByParent',//学生信息 - 学生问卷展示
            },
            parentQues: {
                getParentCensusQuestionByParent: '/customer/getParentCensusQuestionByParent',//学生信息 - 家长问卷展示
            },
            careerReport: {
                getCareerReportIdByStudentIdByParent: '/customer/getCareerReportIdByStudentIdByParent',//家长查看学生生涯测评-获取生涯测评报告id
                getPartBDetailByParent: '/customer/getPartBDetailByParent ',//家长查看学生测评报告解读-获取partB
                getPartADetailByParent: '/customer/getPartADetailByParent ',//家长查看学生测评报告解读-获取partA
                getStudentAndParentInfoByParent:'/customer/getStudentAndParentInfoByParent',
            }
        },
        // 规划内容
        planningContent: {
            getPlanListByParent: '/customer/getPlanListByParent',//家长查看学生规划内容 - 列表
            getPlanByIdByParent: '/customer/getPlanByIdByParent',//家长查看学生规划内容 - 详情
            adjustPlanComparedByParent:'/customer/adjustPlanComparedByParent',//家长查看学生规划内容 - 规划调整报告
        },
        // 计划执行
        implement: {
            getTargetSplitListByParent: '/customer/getTargetSplitListByParent',//家长查看学生-计划执行-目标拆分 - 列表
            getTargetSplitDetailByIdByParent: '/customer/getTargetSplitDetailByIdByParent',//家长查看学生-计划执行-目标拆分 - 详情

            getCurrentSemesterByStudentIdByParent: '/customer/getCurrentSemesterByStudentIdByParent',//家长查看学生 - 计划执行 - 行动计划 - 列表
            getActionPlanListByParent: '/customer/getActionPlanListByParent',//家长查看学生 - 计划执行 - 行动计划 - 列表
            getActionPlanDetailByParent: '/customer/getActionPlanDetailByParent',//家长查看学生 - 计划执行 - 行动计划 - 详情
            getCurrentSemesterConditionalGoals:'/customer/getCurrentSemesterConditionalGoalsByParent',//更新最后一次 当前学期的条件目标

            getStageAssessListByParent: '/customer/getStageAssessListByParent',//家长查看学生 - 计划执行 - 阶段评估 - 列表
            getStageAssessDetailByParent: '/customer/getStageAssessDetailByParent',//家长查看学生 - 计划执行 - 阶段评估 - 详情
        },

        // 咨询记录
        consultationRecord: {
            getStudentInterviewListByParent: '/customer/getStudentInterviewListByParent',//家长查看学生 - 咨询记录 - 学生咨询 - 列表
            getInterviewFreeThemeDetailByParent: '/customer/getInterviewFreeThemeDetailByParent',//家长查看学生 - 咨询记录 - 学生咨询 - 详情
            adjustPlanComparedByParent: '/customer/adjustPlanComparedByParent',//家长查看学生 - 咨询记录 - 学生咨询 - 列表

            getParentInterviewListByParent: '/customer/getParentInterviewListByParent',//家长查看学生 - 咨询记录 - 家长交流 - 列表

            performanceDataAnalysisByParent: '/customer/performanceDataAnalysisByParent',//家长查看学生 - 数据分析
        },
        growth:{
            getLastGrowthFileIdByParent: '/customer/getLastGrowthFileIdByParent',//家长查看学生 - 成长档案 - 返回最新一条成长档案id
            getGrowthFileDetailByParent: '/customer/getGrowthFileDetailByParent',//家长查看学生 - 成长档案 - 查看档案
            getStudentDataByStudentIdByParent: '/customer/getStudentDataByStudentIdByParent',//家长查看学生 - 成长档案 - 查看档案
        },
        //数据分析
        dataAnalysis:{
            actionPlan:'/customer/actionPlanDataAnalysisByParent',//行动计划 ..
            grade:'/customer/performanceDataAnalysisByParent'//成绩 ..
        }

        //
        // //测评报告接口
        // report: {
        //     rgtx:  '/common/report/personality/content',//人格特性
        //     rzqn:  '/common/report/cognition/content',//认知潜能
        //     xqqx:  '/common/report/interest/content',//兴趣倾向
        //     xljk:  '/common/report/mind/content',//心理健康
        //     zylx:  '/common/report/career/content',//职业类型
        // },

    }
}
